module.exports = __webpack_public_path__ + "static/img/default.eacc873.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/default.svg
// module id = KkUm
// module chunks = 1